import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
  border-bottom: 2px solid #0077B5;
  margin-bottom: 30px;
`;

const TitleSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const Icon = styled.span`
  font-size: 32px;
`;

const Title = styled.h1`
  font-family: 'Segoe UI', sans-serif;
  font-size: 24px;
  font-weight: 700;
  color: #2C3E50;
  margin: 0;
`;

const BackButton = styled.button`
  background-color: #0077B5;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  font-family: 'Segoe UI', sans-serif;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #005885;
  }

  &:active {
    transform: scale(0.98);
  }
`;

/**
 * Report Header Component
 * @param {String} icon - Emoji icon for the report
 * @param {String} title - Report title
 * @param {String} backPath - Path to navigate back to (default: /project750k)
 */
const ReportHeader = ({ icon = '📊', title = 'Report', backPath = '/project750k' }) => {
  const navigate = useNavigate();

  return (
    <HeaderContainer>
      <TitleSection>
        <Icon>{icon}</Icon>
        <Title>{title}</Title>
      </TitleSection>
      <BackButton onClick={() => navigate(backPath)}>
        ← Back to Dashboard
      </BackButton>
    </HeaderContainer>
  );
};

export default ReportHeader;


